import { Icon } from '@chakra-ui/icons';

export const PlayCircleIcon = ({ color = 'white' }: { color?: string }) => (
	<Icon
		width="20px"
		height="20px"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M9.83366 17.7284C14.2059 17.7284 17.7503 14.1839 17.7503 9.81169C17.7503 5.43943 14.2059 1.89502 9.83366 1.89502C5.4614 1.89502 1.91699 5.43943 1.91699 9.81169C1.91699 14.1839 5.4614 17.7284 9.83366 17.7284Z"
			stroke={color}
			strokeWidth="1.4"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M8.25098 6.64502L13.001 9.81169L8.25098 12.9784V6.64502Z"
			stroke={color}
			strokeWidth="1.4"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</Icon>
);
